import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditableTable from './EditableTable';
import { alertObjType } from '../../../../features/alerts/types';
import { useLocation } from 'react-router-dom';
import { getAlertByClients } from '../../../../features/alerts/requests';
import { sendAnalyticsEvent } from '../../../../utils/googleAnalytics';

type Props = {};

const AlertDetailSetter: FC<Props> = () => {
  const { t } = useTranslation();
  const [alertFromApi, setAlertFromApi] = useState<alertObjType[]>([]);
  const [selectedAlert, setSelectedAlert] = useState<null | alertObjType>(null);
  const location = useLocation();

  // 初めてランディングした時にアラート条件を取得する.
  useEffect(() => {
    const initialId = new URLSearchParams(location.search).get('id');
    getAlertByClients().then((res: alertObjType[]) => {
      setAlertFromApi(res);
      const initialAlert = res.filter(r => String(r.id) === String(initialId));
      setSelectedAlert(initialAlert.length > 0 ? initialAlert[0] : null);
    });
  }, []);

  const handleAreaChange = (e: SelectChangeEvent) => {
    // GA4: アラート条件設定の対象アラート変更を計測
    sendAnalyticsEvent('alert_condition', {
      action: 'change_target_alert',
    });
    setSelectedAlert(alertFromApi[Number(e.target.value)]);
  };

  return (
    <>
      <Box>
        <Box style={{ display: 'flex' }}>
          <Typography style={{ fontWeight: 'bold', fontSize: '12pt' }}>
            {t('common.menu.alertDetail')}
          </Typography>

          <Box style={{ marginLeft: '36px' }}>
            <FormControl fullWidth>
              <InputLabel id="area-select" style={{ fontSize: '12pt' }}>
                {t('pages.alerts.areaName')}
              </InputLabel>
              <Select
                labelId="area-select"
                style={{ width: '200px' }}
                onChange={handleAreaChange}
                value={
                  selectedAlert
                    ? String(alertFromApi.findIndex(a => a.id === selectedAlert.id))
                    : ''
                }
              >
                {alertFromApi.map((a, idx) => {
                  return (
                    <MenuItem value={idx} key={idx}>
                      {a.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box style={{ marginTop: '24px' }}>
          <EditableTable selectedAlert={selectedAlert} />
        </Box>
      </Box>
    </>
  );
};

export default AlertDetailSetter;
